<!-- Modal Header -->
<div class="modal-header">
  <h5 class="modal-title" id="renewalModalLabel">
    <i class="fas fa-sync-alt"></i> Renewal
  </h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="renewalForm" style="background-color: white; padding: 20px; border-radius: 5px;">

    <!-- Member Selection (single) -->
    <div class="form-group">
      <label for="member">Member:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Select the member who is renewing the item(s)."></i>
      <ng-select id="member"
                 [items]="members$"
                 bindLabel="firstname"
                 bindValue="id"
                 formControlName="member"
                 placeholder="Select a member">
      </ng-select>
      <small class="text-danger"
             *ngIf="submitted && renewalForm.get('member').invalid">
        Member is required.
      </small>
    </div>

    <!-- Item Barcode Multi-Selection -->
    <div class="form-group">
      <label for="itemBarcodes">Item Barcodes:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Select one or more items you wish to renew."></i>
      <ng-select id="itemBarcodes"
                 [items]="books$"
                 bindLabel="title"
                 bindValue="id"
                 formControlName="itemBarcodes"
                 placeholder="Select barcode(s)"
                 [multiple]="true"
                 [closeOnSelect]="false"
                 [clearable]="true">
      </ng-select>
      <small class="text-muted">You can select multiple items at once.</small>
      <small class="text-danger d-block"
             *ngIf="submitted && renewalForm.get('itemBarcodes').value?.length === 0">
        Please select at least one item.
      </small>
    </div>

    <!-- Renewal Due Date -->
    <div class="form-group">
      <label for="renewalDueDate">Renewal Due Date:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Enter the due date for the renewed item(s)."></i>
      <input type="date" class="form-control" id="renewalDueDate"
             formControlName="renewalDueDate">
      <small class="text-danger"
             *ngIf="submitted && renewalForm.get('renewalDueDate').invalid">
        Renewal due date is required.
      </small>
    </div>

    <!-- Forgive Fines on Return -->
    <div class="form-group">
      <label>Forgive fines on return:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Choose whether to forgive any fines incurred by the member on returning these items."></i>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="forgiveFinesYes"
               value="yes" formControlName="forgiveFines">
        <label class="form-check-label" for="forgiveFinesYes">Yes</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="forgiveFinesNo"
               value="no" formControlName="forgiveFines">
        <label class="form-check-label" for="forgiveFinesNo">No</label>
      </div>
      <small class="text-danger d-block"
             *ngIf="submitted && renewalForm.get('forgiveFines').invalid">
        Please select a fine forgiveness option.
      </small>
    </div>

  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Close</button>
  <button type="button" class="btn btn-outline-primary" (click)="renew()">
    <i class="fas fa-sync-alt"></i> Renew
  </button>
</div>